import { Component, inject, signal } from '@angular/core';
import { email, form, FormField, FormRoot, required } from '@angular/forms/signals';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app/shared/services';
import { lastValueFrom } from 'rxjs';

interface LoginData {
	email: string;
	password: string;
}

@Component({
	selector: 'ziggy-login',
	
	imports: [FormField, FormRoot],
	templateUrl: './login.component.html',
})
export class LoginComponent {
	readonly #router = inject(Router);
	readonly #route = inject(ActivatedRoute);
	readonly #userService = inject(UserService);

	loading = signal(false);

	loginModel = signal<LoginData>({
		email: '',
		password: '',
	});

	loginForm = form(
		this.loginModel,
		(schemaPath) => {
			required(schemaPath.email, { message: 'Champ requis' });
			required(schemaPath.password, { message: 'Champ requis' });
			email(schemaPath.email, { message: 'Email invalide' });
		},
		{
			submission: {
				action: async () => this.onSubmit(),
			},
		},
	);

	async onSubmit() {
		if (this.loginForm().valid()) {
			this.loading.set(true);
			try {
				await lastValueFrom(this.#userService.login(this.loginModel()));
				const returnUrl = this.#route.snapshot.queryParams['returnUrl'];
				this.loading.set(false);
				await this.#router.navigateByUrl(returnUrl || '/');
			} catch (_e) {
				this.loading.set(false);
			}
			
		}
	}
}
